// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__hJVof","row":"ProcedureTreatmentSummary_row__YpCmb"};